import constate from "constate";
import { useState } from "react";

export type TSwitchAnimation =
  | "fade"
  | "fade-move-from-bottom"
  | "fade-move-from-center"
  | "fade-move-from-end"
  | "move-from-side"
  | "none";

export type TTransitionAnimationOptions = {
  animate: boolean;
  animation: TSwitchAnimation;
  movement: "in" | "out" | "standstill";
  reverse: boolean;
};

const DEFAULT_OPTIONS: TTransitionAnimationOptions = {
  animate: false,
  animation: "fade-move-from-center",
  movement: "standstill",
  reverse: false,
};

const useTransitionAnimation = ({ options = DEFAULT_OPTIONS }: { options?: TTransitionAnimationOptions }) => {
  const [animationIsRunning, setAnimationIsRunning] = useState(false);

  return { animationIsRunning, setAnimationIsRunning, transitionOptions: options };
};

export const [TransitionAnimationProvider, useTransitionAnimationContext] = constate(useTransitionAnimation);
